define('modules/editor/views/controls/resizebox',['require','exports','module','./resizebar','ldsh!../../templates/controls/resize_top','ldsh!../../templates/controls/resize_bottom','ldsh!../../templates/controls/resize_left','ldsh!../../templates/controls/resize_right'],function(require, exports, module){
  "use strict";
  var ResizeBar = require("./resizebar");

  /**
   * ResizeBox views - View
   * Used to display the resize box around the
   * selected element in the editor
   *
   * In order to allow clicking through the resize box
   * it has to be formed with 4 views - one for each edge.
   * This is the reason why this module exports 4 views
   *
   * Lifecycle is managed from HasResizeBox behaviour
   */



  /**
   * ResizeTopBar View
   * Handles resizing northwest, north and northeast
   */
  var ResizeTopBar = ResizeBar.extend({
    template: require("ldsh!../../templates/controls/resize_top"),
    className: "resize-box h-side",
    //given a selected element view and options, position the top bar
    configure: function(elementView, options){
      var geo = this.getElementPageGeometry(elementView);
      this.$el
        .css("top", parseInt(geo.top) + "px")
        .css("left", parseInt(geo.left) + "px")
        .css("width", geo.width + "px")
        .css("zIndex", 2000);
      //show handles only if you can modify height
      this.$(".handle.tc").toggle(elementView.model.name !== "section" &&
        options.height);
      this.$(".handle.tl").toggle(elementView.model.name !== "section" &&
        options.height || options.width);
      this.$(".handle.tr").toggle(elementView.model.name !== "section" &&
        options.height || options.width);
    },
    /**
     * Does the real transformation
     * @param  {Object} eventData { direction, deltaX, deltaY, origTop, origLeft, origWidth, origHeight }
     * @return {Object}           { newTop, newLeft, newHeight, newWidth }
     */
    _processResize: function(eventData){
      var resizeData = {},
          newWidth,
          newHeight;
      if(eventData.direction === "nw"){
        if(eventData.deltaX !== 0){
          //move element left
          if(eventData.origLeft !== undefined){
            resizeData.newLeft = eventData.origLeft + eventData.deltaX;
          }
          //and modify width if not at 0
          if(eventData.origWidth !== undefined && eventData.origLeft > 0){
            newWidth = eventData.origWidth - eventData.deltaX;
            resizeData.newWidth = this._adjustToRightBound(newWidth);
          }

        }
        if(eventData.deltaY !== 0){
          //move element top
          if(eventData.origTop !== undefined && !isNaN(eventData.origHeight)){
            resizeData.newTop = eventData.origTop + eventData.deltaY;
          }
          //and modify height if not at 0
          if(eventData.origHeight !== undefined && eventData.origTop > 0){
            newHeight = eventData.origHeight - eventData.deltaY;
            resizeData.newHeight = this._adjustToBottomBound(newHeight);
          }
        }
      }
      if(eventData.direction === "n"){
        if(eventData.deltaY !== 0){
          //move element top and modify width
          if(eventData.origTop !== undefined){
            resizeData.newTop = eventData.origTop + eventData.deltaY;
          }
          if(eventData.origHeight !== undefined && eventData.origTop > 0){
            newHeight = eventData.origHeight - eventData.deltaY;
            resizeData.newHeight = this._adjustToBottomBound(newHeight);
          }
        }
      }
      if(eventData.direction === "ne"){
        if(eventData.deltaX !== 0){
          //modify width
          if(eventData.origWidth !== undefined){
            newWidth = eventData.origWidth + eventData.deltaX;
            resizeData.newWidth = this._adjustToRightBound(newWidth);
          }
        }
        if(eventData.deltaY !== 0){
          //move element top
          if(eventData.origTop !== undefined && !isNaN(eventData.origHeight)){
            resizeData.newTop = eventData.origTop + eventData.deltaY;
          }
          //and modify height if not at 0
          if(eventData.origHeight !== undefined && eventData.origTop > 0){
            newHeight = eventData.origHeight - eventData.deltaY;
            resizeData.newHeight = this._adjustToBottomBound(newHeight);
          }
        }
      }
      return _.extend(eventData, resizeData);
    }
  });

  /** ResizeBottomBar View */
  var ResizeBottomBar = ResizeBar.extend({
    template: require("ldsh!../../templates/controls/resize_bottom"),
    className: "resize-box h-side",
    configure: function(elementView, options){
      var geo = this.getElementPageGeometry(elementView);
      this.$el.css({
        top: (parseInt(geo.top) + parseInt(geo.height)) + "px",
        left: geo.left + "px",
        width: geo.width + "px",
        zIndex: 2000
      });
      //show handles only if you can modify height
      this.$(".handle.bc").toggle(options.height);
      this.$(".handle.bl").toggle(options.height || options.width);
      this.$(".handle.br").toggle(options.height || options.width);
    },
    _processResize: function(eventData){
      var resizeData = {},
          newHeight,
          newWidth;
      if(eventData.direction === "sw"){
        if(eventData.deltaX !== 0){
          //move element left
          if(eventData.origLeft !== undefined){
            resizeData.newLeft = eventData.origLeft + eventData.deltaX;
          }
          //and modify width if not at 0
          if(eventData.origWidth !== undefined && eventData.origLeft > 0){
            newWidth = eventData.origWidth - eventData.deltaX;
            resizeData.newWidth = this._adjustToRightBound(newWidth);
          }

        }
        if(eventData.deltaY !== 0){
          //modify height
          if(eventData.origHeight !== undefined){
            newHeight = eventData.origHeight + eventData.deltaY;
            resizeData.newHeight = this._adjustToBottomBound(newHeight);
          }
        }
      }
      if(eventData.direction === "s"){
        if(eventData.deltaY !== 0){
          //modify height
          if(eventData.origHeight !== undefined){
            newHeight = eventData.origHeight + eventData.deltaY;
            resizeData.newHeight = this._adjustToBottomBound(newHeight);
          }
        }
      }
      if(eventData.direction === "se"){
        if(eventData.deltaX !== 0){
          //modify width
          if(eventData.origWidth !== undefined){
            newWidth = eventData.origWidth + eventData.deltaX;
            resizeData.newWidth = this._adjustToRightBound(newWidth);
          }
        }
        if(eventData.deltaY !== 0){
          //modify height
          if(eventData.origHeight !== undefined){
            newHeight = eventData.origHeight + eventData.deltaY;
            resizeData.newHeight = this._adjustToBottomBound(newHeight);
          }
        }
      }
      return _.extend(eventData, resizeData);
    }
  });

  /** ResizeLeftBar View */
  var ResizeLeftBar = ResizeBar.extend({
    template: require("ldsh!../../templates/controls/resize_left"),
    className: "resize-box v-side",
    configure: function(elementView, options){
      var geo = this.getElementPageGeometry(elementView);
      this.$el.css({
        top: geo.top + "px",
        left: geo.left + "px",
        height: geo.height + "px",
        zIndex: 2000
      });
      //show handles only if you can modify height
      this.$(".handle").toggle(options.width);
    },
    _processResize: function(eventData){
      var resizeData = {};
      if(eventData.direction === "w"){
        if(eventData.deltaX !== 0){
          //move element left
          if(eventData.origLeft !== undefined){
            resizeData.newLeft = eventData.origLeft + eventData.deltaX;
          }
          //and modify width if not at 0
          if(eventData.origWidth !== undefined && eventData.origLeft > 0){
            var newWidth = eventData.origWidth - eventData.deltaX;
            resizeData.newWidth = this._adjustToRightBound(newWidth);
          }

        }
      }
      return _.extend(eventData, resizeData);
    }

  });

  /** ResizeRightBar View */
  var ResizeRightBar = ResizeBar.extend({
    template: require("ldsh!../../templates/controls/resize_right"),
    className: "resize-box v-side",
    configure: function(elementView, options){
      var geo = this.getElementPageGeometry(elementView);
      this.$el.css({
        top: geo.top + "px",
        left: (parseInt(geo.left) + parseInt(geo.width)),
        height: geo.height + "px",
        zIndex: 2000
      });
      //show handles only if you can modify height
      this.$(".handle").toggle(options.width);
    },
     _processResize: function(eventData){
      var resizeData = {};
      if(eventData.direction === "e"){
        if(eventData.deltaX !== 0){
          //modify width
          if(eventData.origWidth !== undefined){
            var newWidth = eventData.origWidth + eventData.deltaX;
            resizeData.newWidth = this._adjustToRightBound(newWidth);
          }

        }
      }
      return _.extend(eventData, resizeData);
    }
  });

  module.exports = {
    TopBar: ResizeTopBar,
    BottomBar: ResizeBottomBar,
    LeftBar: ResizeLeftBar,
    RightBar: ResizeRightBar
  };
});

